import { useState } from 'react';
import Markdown from 'react-markdown';
import { slugifyHeading } from '@/utils/glossary-toc';

const ChevronDown = ({ className = '' }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const FaqItem = ({ item, isOpen, onToggle }) => {
  return (
    <div className="border-grey-200 border-b">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={isOpen}
        className="text-grey-900 flex w-full items-center justify-between gap-4 py-5 text-left text-base font-semibold"
      >
        <span>{item.question}</span>
        <ChevronDown className={`shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      {isOpen && (
        <div className="text-grey-600 pb-5 text-[15px] leading-relaxed [&_strong]:font-bold">
          <Markdown>{item.answer || ''}</Markdown>
        </div>
      )}
    </div>
  );
};

const GlossaryFaq = ({ title, items = [] }) => {
  const [openIds, setOpenIds] = useState(() => new Set());

  if (items.length === 0) return null;

  const toggle = (id) => {
    setOpenIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const headingId = title ? slugifyHeading(title) : undefined;

  return (
    <section className="my-2">
      {title && (
        <h2 id={headingId} className="mb-4">
          {title}
        </h2>
      )}
      <div>
        {items.map((item) => (
          <FaqItem key={item.id} item={item} isOpen={openIds.has(item.id)} onToggle={() => toggle(item.id)} />
        ))}
      </div>
    </section>
  );
};

export default GlossaryFaq;
